import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.025 9.776a.98.98 0 0 0-1.4 0l-9.2 8.994c-2 1.955-5.1 1.955-7.1 0s-2-4.986 0-6.94l9.2-8.995c1.1-1.075 3.1-1.075 4.2 0 1.2 1.174 1.2 3.031 0 4.106l-9.2 8.994c-.4.391-1 .391-1.4 0-.1-.098-.2-.293-.2-.586 0-.294.1-.49.3-.685l8.5-8.31a.93.93 0 0 0 0-1.368.98.98 0 0 0-1.4 0l-8.5 8.31c-.6.488-.9 1.27-.9 2.053s.3 1.564.9 2.052c1.2 1.174 3.1 1.174 4.2 0l9.2-8.993c2-1.955 2-4.986 0-6.941-.9-.88-2.2-1.467-3.5-1.467s-2.6.49-3.5 1.467l-9.2 8.994c-2.7 2.639-2.7 7.037 0 9.677 1.4 1.368 3.2 1.955 5 1.955s3.6-.684 5-1.955l9.2-8.994c.2-.293.2-.977-.2-1.368"
    }, null, -1)
  ]))]))
}
export default { render: render }